import { Injectable } from '@angular/core';
import { UploadStorage } from './upload-storage';
import { HttpEvent } from '@angular/common/http';
import { Settings } from '../../../core';
import { UploadedDocumentsRequestCreator } from './uploaded-documents-request-creator';
import { Category, CategoryNaturalKey } from '../../../documents';
import { CultureInfo } from '../../../core/culture-info';
import { Observable } from 'rxjs';
import { ActivityLogger } from '../../../activities/activity-logger';
import { isDefined } from '@angular/compiler/src/util';

@Injectable()
export class ELearningUploadStorage implements UploadStorage {

    constructor(
        private readonly settings: Settings,
        private readonly uploadRequestCreator: UploadedDocumentsRequestCreator,
        private readonly activityLogger: ActivityLogger,
    ) {
    }

    public create<T>(categoryId: CategoryNaturalKey, files: Map<File, CultureInfo>, documentMetadata: T): Observable<HttpEvent<Object>> {
        this.activityLogger.logUploadActivity(categoryId);

        if (Category.isELearningCategory(categoryId) && !Category.isTrainingMaterialsELearning(categoryId)) {
            return this.uploadRequestCreator.createPost(`${this.settings.apiUrl}/admin/e-learning/${categoryId}/upload`, files, documentMetadata);
        } else if (Category.isTrainingMaterialsOthers(categoryId)) {
            return this.uploadRequestCreator.createPost(`${this.settings.apiUrl}/admin/training-materials/others-upload`, files, documentMetadata);
        } else if (Category.isTrainingMaterialsELearning(categoryId)) {
            return this.uploadRequestCreator.createPost(`${this.settings.apiUrl}/admin/training-materials/eLearnings-upload`, files, documentMetadata);
        } else {
            return this.uploadRequestCreator.createPost(`${this.settings.apiUrl}/admin/uploaded-documents/${categoryId}`, files, documentMetadata);
        }
    }

    public update(categoryId: CategoryNaturalKey, files: Map<File, CultureInfo>, documentId: string, auditTrailReason: string): Observable<HttpEvent<Object>> {
        this.activityLogger.logEditFileActivity(documentId);

        return this.uploadRequestCreator.createPut(`${this.settings.apiUrl}/admin/e-learning/${categoryId}/update/${documentId}`, files, auditTrailReason);
    }
}